// ABOUTME: Software News management page for SHA admin users.
// ABOUTME: Two-tab TabView3 — news articles and meldingen authoring.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TabView3 from "../../../components/theme/TabView3/TabView3";
import { tokens } from "../../../theme";
import { softwareNewsConfig } from "./softwareNewsConfig";
import All from "./views/All";
import Meldingen from "./views/Meldingen";

const SoftwareNews = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                background: "",
                width: 1,
                paddingTop: 9,
            }}
        >

            <TabView3
                tabConfig={softwareNewsConfig}
                sx={{
                    background: "green",
                    minHeight: "calc(100%)",
                    background: `${
                        theme.palette.mode === "dark"
                        ? colors.grey[200]
                        : colors.grey[0]
                    }`,
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    "&:before": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        left: 0,
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms"
                    },
                    "&:after": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        right: 0,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms"
                    },
                    "@media screen and (max-width: 47.9375em)": {
                        "&:before, &:after": {
                            top: 0,
                            width: "24px",
                        }
                    }
                }}
            >
                <>
                    <All config={softwareNewsConfig.all} />
                    <Meldingen config={softwareNewsConfig.meldingen} />
                </>
            </TabView3>
        </Box>
    )
};

export default SoftwareNews;
